import $ from "./jquery"
import JSZip from "jszip"

// Use CJS entrypoints + call factories. The ESM (.mjs) path pulls nested
// datatables.net@3.x (from datatables.net-bs5) which breaks pageButton renderer.
import dataTablesFactory from "datatables.net/js/jquery.dataTables.js"
import bootstrap5Factory from "datatables.net-bs5/js/dataTables.bootstrap5.js"
import buttonsFactory from "datatables.net-buttons/js/dataTables.buttons.js"
import buttonsHtml5Factory from "datatables.net-buttons/js/buttons.html5.js"

window.JSZip = JSZip

const load = (mod, ...args) => {
  const factory = mod?.default ?? mod
  return typeof factory === "function" ? factory(window, $, ...args) : factory
}

if (!$.fn.dataTable) load(dataTablesFactory)
load(bootstrap5Factory)
load(buttonsFactory)
load(buttonsHtml5Factory, JSZip)

window.DataTable = $.fn.DataTable
window.dataTable = $.fn.dataTable

export default $.fn.DataTable
